import { Component, OnChanges, OnInit, inject, input } from '@angular/core';
import { HasPermissionService } from 'src/app/services/common/has-permission.service';
import { ConstantService, UserRoles } from 'src/app/services/common/constant.service';

import { TranslatePipe } from '@ngx-translate/core';
@Component({
    selector: 'super-admin-tenant-warning',
    templateUrl: './super-admin-tenant-warning.component.html',
    styleUrl: './super-admin-tenant-warning.component.scss',
    imports: [TranslatePipe]
})
export class SuperAdminTenantWarningComponent implements OnInit {
   private permissions = inject(HasPermissionService);
   private constantService = inject(ConstantService);


   readonly mode = input<'default' | 'new'>('default');

  isSuperAdmin = false;
  shouldShow = false;
  displayTenantName: string | null = null;

  ngOnInit(): void {
    this.isSuperAdmin = this.permissions.allowAccess([UserRoles.SuperAdmin]);

    // Defer to allow tenant data to be available
    setTimeout(() => this.updateState());
  }

  ngOnChanges(): void {
    this.updateState();
  }

  private updateState(): void {
    const defaultTenant = this.constantService.getDefaultTenant();
    const currentTenant = this.constantService.mspTenant?.organizationName;

    this.shouldShow = this.isSuperAdmin &&!!defaultTenant && !!currentTenant && defaultTenant !== currentTenant;

    this.displayTenantName = this.shouldShow ? (this.mode() === 'default' ? defaultTenant : currentTenant): null;
  }
}